import React from 'react';

export const ancillaryFormsWizardDescription = (
  <div>
    <p>You may also be eligible for these additional disability benefits:</p>
    <ul>
      <li>Money to modify your home or vehicle to make it more accessible</li>
      <li>
        Home-based care if you need help with everyday activities or are
        housebound because of a service-connected condition or disability
      </li>
      <li>
        Individual Unemployability benefits (this includes increased disability
        payments) if a service-connected condition or disability prevents you
        from keeping a job
      </li>
    </ul>
    <p>
      If we think you may be eligible for these benefits, we’ll tell you which
      additional forms you’ll need to fill out to apply.
    </p>
  </div>
);
